var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('h2',[_vm._v(" Välkommen till Online-Analys ")]),_c('br'),_c('p',[_vm._v("Gör ett val ovan för att komma igång")])])
}]

export { render, staticRenderFns }